<template>
  <fragment>
    <router-view></router-view>
  </fragment>
</template>

<script>
export default {
  name: "QtimeReports"
};
</script>

<style scoped>
</style>
